(function() {
  'use strict';

  class TickerBar {
    constructor(element) {
      this.tickerBar = element;
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;

      if (this.tickerBar) {
        this.init();
      }
    }

    init() {
      // 鼠标按下
      this.tickerBar.addEventListener('mousedown', (e) => this.onMouseDown(e));
      // 鼠标离开
      this.tickerBar.addEventListener('mouseleave', () => this.onMouseLeave());
      // 鼠标松开
      this.tickerBar.addEventListener('mouseup', () => this.onMouseUp());
      // 鼠标移动
      this.tickerBar.addEventListener('mousemove', (e) => this.onMouseMove(e));

      // 设置默认鼠标样式
      if (this.tickerBar.scrollWidth > this.tickerBar.clientWidth) {
        this.tickerBar.style.cursor = 'grab';
      }
    }

    onMouseDown(e) {
      this.isDown = true;
      this.tickerBar.style.cursor = 'grabbing';
      this.startX = e.pageX - this.tickerBar.offsetLeft;
      this.scrollLeft = this.tickerBar.scrollLeft;
      e.preventDefault();
    }

    onMouseLeave() {
      this.isDown = false;
      this.tickerBar.style.cursor = 'grab';
    }

    onMouseUp() {
      this.isDown = false;
      this.tickerBar.style.cursor = 'grab';
    }

    onMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.tickerBar.offsetLeft;
      const walk = (x - this.startX) * 1.5; // 滚动速度
      this.tickerBar.scrollLeft = this.scrollLeft - walk;
    }
  }

  // 初始化所有 ticker-bar
  function initTickerBars() {
    document.querySelectorAll('.ticker-bar').forEach((el) => new TickerBar(el));
  }

  // DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTickerBars);
  } else {
    // DOM 已经加载完成
    initTickerBars();
  }
})();
